import { render, staticRenderFns } from "./StockShare.vue?vue&type=template&id=317a83a6&scoped=true&"
import script from "./StockShare.vue?vue&type=script&lang=js&"
export * from "./StockShare.vue?vue&type=script&lang=js&"
import style0 from "./StockShare.vue?vue&type=style&index=0&id=317a83a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317a83a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VTextField})
